import type {RouteRecordRaw} from 'vue-router';

export const collectTripRoutes: RouteRecordRaw[] = [
  {
    name: 'collect-trip',
    path: '/collect-trip',
    component: () => import('@/views/CollectTrip/CollectTripOverview/CollectTripOverview.vue'),
    meta: {
      title: (t) => t('collectTrip.title'),
      feature: 'page.collectTrip',
      permissions: ['accessCollectTrip'],
    },
  },
  {
    name: 'collect-trip-create',
    path: '/collect-trip/create',
    component: () => import('@/views/CollectTrip/CollectTripCreate/CollectTripCreate.vue'),
    meta: {
      title: (t) => t('collectTrip.create'),
      feature: 'page.collectTrip',
      permissions: ['accessCollectTrip'],
    },
  },
  {
    name: 'collect-trip-incidental',
    path: '/collect-trip/incidental/:id',
    props: true,
    component: () => import('@/views/CollectTrip/CollectTripIncidental/CollectTripIncidental.vue'),
    meta: {
      title: (t) => t('collectTrip.edit'),
      feature: 'page.collectTrip',
      permissions: ['accessCollectTrip'],
    },
  },
  {
    name: 'collect-trip-structural',
    path: '/collect-trip/structural/:id',
    props: true,
    component: () => import('@/views/CollectTrip/CollectTripStructural/CollectTripStructural.vue'),
    meta: {
      title: (t) => t('collectTrip.edit'),
      feature: 'page.collectTrip',
      permissions: ['accessCollectTrip'],
    },
  },
];
